<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.9999 11.1922C11.4358 11.1922 12.5999 10.0281 12.5999 8.59219C12.5999 7.15625 11.4358 5.99219 9.9999 5.99219C8.56396 5.99219 7.3999 7.15625 7.3999 8.59219C7.3999 10.0281 8.56396 11.1922 9.9999 11.1922Z"
      :stroke="props.color" stroke-width="1.5" />
    <path
      d="M3.01675 7.07435C4.65842 -0.142316 15.3501 -0.133982 16.9834 7.08268C17.9418 11.316 15.3084 14.8994 13.0001 17.116C11.3251 18.7327 8.67508 18.7327 6.99175 17.116C4.69175 14.8994 2.05842 11.3077 3.01675 7.07435Z"
      :stroke="props.color" stroke-width="1.5" />
  </svg>
</template>

<script setup>

import { defineProps } from 'vue';

const props = defineProps({
  color: {
    type: String,
    default: 'rgb(var(--locumate-primary-color))',
  },
});

</script>